import {
  DIM2CLASS
} from '../../core/icon-class';
import {
  Filter
} from '../../common/filter';
import {
  boolDialogCtrl
} from '../../admin/modals';
import {
  getFilterIcon
} from '../../common/filter-mode';

require('./filter-editor-modal.component.scss');

export const FilterEditorModalController = function(
  $scope,
  $http,
  $modal,
  $timeout,
  $modalInstance,
  FilterResource,
  Aggregates,
  filter,
  CurrentFilterService,
  FilterDataFactory,
  CurrentModelService,
  model,
  asNew,
  globalAlert,
  ErrorHandlerService,
  StatusCheckerService,
  RouterService,
  tabName,
) {
  $scope.testMail = true;
  $scope.notify2 = {};
  $scope.$timeout = $timeout;
  $scope.successSended = false;
  let jastOpened = true;
  $scope.model = model;
  $scope.$http = $http;
  $scope.ErrorHandlerService = ErrorHandlerService;
  $scope.CurrentFilterService = CurrentFilterService;
  $scope.RouterService = RouterService;
  this.CurrentModelService = CurrentModelService;
  $scope.visibleDimensions = model.dimensions;
  $scope.DIM2CLASS = DIM2CLASS;
  $scope.cube = model.cubes[0];
  $scope.filterAsText = {};
  $scope.awaiting = false;
  $scope.errorMessage = $scope.ErrorHandlerService.filterErrorMessage;
  $scope.errorMessage.filterUnchecked = false;
  $scope.errorMessage.notReload = true;
  $scope.ErrorHandlerService.notShowErrorMessageBox = true;
  $scope.filterBar = new Filter('DialogBar');
  $scope.filter = angular.copy(filter);
  $scope.filterData = FilterDataFactory(true);
  if (asNew) {
    delete $scope.filter.id;
    $scope.CurrentFilterService.setFilterName($scope.filter);
  }

  if ($scope.filter.isCardFilter && $scope.CurrentFilterService.filter.id === $scope.filter.id)
    $scope.filter.children = $scope.CurrentFilterService.filter.children;
  $scope.filterBar.skipStat = true;
  $scope.filterBar.limit = 100;
  $scope.serverPolicies = false;
  $scope.showDeleteButton = true;
  $scope.StatusChecker = StatusCheckerService;
  $scope.currentTab = tabName == 'QueryTab' ? 'filters' : 'prop';
  $scope.filterTab = tabName == 'QueryTab' ? 'query' : 'filter';

  $scope.setTab = tab => {
    $scope.currentTab = tab;
    $scope.$broadcast('changeTab');
  };

  $scope.getOriginalFilter = (id) => {
    if ($scope.originalFilter) return $scope.originalFilter;
    if (!id) id = $scope.filter.id;
    if (!id) return null;
    $scope.originalFilter = CurrentFilterService.FiltersService.findById(id);
    return $scope.originalFilter;
  };

  $scope.emailTemplete = {
    show: false
  };
  $scope.setTrueemailTemplete = () => $scope.emailTemplete.show = true;

  $scope.isFilterChanged = () => {
    if (!$scope.filter.id) {
      $scope.filter.isChanged = true;
      return true;
    }
    $scope.filter.isChanged = false;
    const f = new Filter();
    $scope.filter.isChanged = !angular.equals($scope.getOriginalFilter(), $scope.filter);
    return $scope.filter.isChanged;
  };

  $scope.showApplyType = () => {
    return $scope.filter.content_type !== 'filter' && $scope.filter.content_type !== 'dashboard' &&
      $scope.filter.content_type !== 'folder' && $scope.filter.content_type !== 'backupfilter';
  };
  const initApplyType = () => $scope.filter.applyType = ($scope.filter.id && !$scope.filter.applyType) ? 'continue' : 'new';

  if ($scope.showApplyType()) initApplyType();
  $scope.toggleDo_scan = () => {
    if ($scope.filter.do_scan) {
      $scope.filter.notify = false;
      $scope.filter.report_if_filter_data_exists = false;
    } else {
      if ($scope.showApplyType()) initApplyType();
    }
  };

  $scope.filterIcon = () => getFilterIcon($scope.filter);

  $scope.filterHeader = () => {
    if (!$scope.filter.content_type) return $scope.filter.name;
    const type = $scope.CurrentFilterService.PermissionService.types[$scope.filter.content_type];
    return type && $scope.filter.name !== type.name ? `${type.name}: ${$scope.filter.name}` : `${$scope.filter.name}`;
  };

  $scope.updateAsText = () => {
    const filtersText = $scope.filter.as_text();
    const queryText = $scope.filter.query ? JSON.stringify(JSON.parse(angular.toJson($scope.filter.query)), null, ' ') : '';

    $scope.filterAsText.code = `${filtersText}
${queryText}`;
    if ($scope.errorMessage.sourse !== 'query-text') {
      $scope.findFilterError('query-filter');
    }
  };

  $scope.findFilterError = type => {
    $scope.errorMessage.sourse = type;
    if (!$scope.ErrorHandlerService.isWrongCuts($scope.filter.filters)) {
      $scope.errorMessage.text = $scope.filter.getFilterError();
      if (!$scope.errorMessage.text)
        $scope.errorMessage.text = this.CurrentModelService.model.checkIsFilterCutsValueAllowed($scope.filter);
    }
    $scope.errorMessage.filterUnchecked = false;
  };

  $scope.$watch('filter', () => {
    $scope.updateAsText();
    if (jastOpened) jastOpened = false;
    else if ($scope.filter.isPolitic) $scope.filterData.update($scope.filter);
  }, true);


  const getNotJson = text => {
    const regExp = /{[^{}]*}/gm;
    let prevText;
    do {
      prevText = text;
      text = prevText.replace(regExp, '');
    } while (text != prevText);
    return text;
  };

  const getJson = text => {
    let i1 = -1;
    let counter = 0;
    for (let i = 0; i < text.length; i++) {
      if (text[i] === '{') {
        counter++;
        if (i1 === -1) i1 = i;
      } else if (text[i] === '}') {
        counter--;
        if (!counter && i > i1) return text.substring(i1, i + 1);
      }
    }
    return '';
  };

  $scope.updateFromText = () => {
    $scope.filter.from_text(getNotJson($scope.filterAsText.code));
    $scope.findFilterError('data-filter');
    queryAsTextChange();
  };

  $scope.onQueryTextCotFocus = () => {
    $scope.errorMessage.filterUnchecked = true;
    $scope.errorMessage.text = gettext('Для сохранения кода фильтра переместите фокус мышки из текстового редактора на любую другую часть формы');
  };

  const isValidQueryText = text => {
    return !!text.match(/(?=.*\boperator\b)*(?=.*\brules\b)/);
  };

  const queryAsTextChange = () => {
    let textQuery = getJson($scope.filterAsText.code);
    if (!isValidQueryText(textQuery)) {
      textQuery = '{\n  "operator": "AND",\n  "rules": []\n }';
    }

    try {
      const query = JSON.parse(textQuery);
      if (!angular.equals($scope.filter.query, query)) $scope.filter.query = query;

    } catch (err) {
      $scope.errorMessage.text = err.message;
      $scope.errorMessage.sourse = 'query-text';
      console.error(err.message);
    }
  };

  $scope.openNodes = {};

  $scope.locLabel = Filter.locLabel;

  $scope.isNodeOpen = function(type, obj) {
    return $scope.openNodes[type] == obj;
  };

  $scope.closeNode = function(type, obj) {
    $scope.openNodes[type] = false;
  };

  $scope.switchNode = function(type, obj, $event) {
    if ($scope.isNodeOpen(type, obj)) $scope.closeNode(
      type,
      obj,
    );
    else $scope.openNode(type, obj);
    if ($event) $event.stopPropagation();
  };

  $scope.openNode = function(type, obj) {
    $scope.closeNode(type, obj);
    $scope.openNodes[type] = obj;
  };

  $scope.cells = function() {
    return $scope.aggregate ? $scope.aggregate.cells : [];
  };

  $scope.loadAggregate = function(callback, resetCache) {
    if ($scope.aggregate) {
      $scope.aggregate.blocked = true;
    }
    if (resetCache) $scope.filterBar.page = 0;
    const canceler = null;
    $scope.filterBar.copyFrom($scope.filter, true);
    delete $scope.filterBar.timeFrom;
    delete $scope.filterBar.timeTo;
    $scope.drill = $scope.filterBar.drilldown[0];

    if ($scope.filter.content_type === 'backupfilter') {
      $scope.serverPolicies = true;
    }

    if (!$scope.filter.id || $scope.filter.id < 1000 || $scope.serverPolicies) {
      $scope.showDeleteButton = false;
    }

    if ($scope.aggregate && $scope.filterBar.page === 0) {
      $scope.aggregate = null;
    }
    $scope.drill = $scope.filterBar.drilldown[0];
    Aggregates.load(
        $scope.cube.name,
        $scope.filterBar,
        resetCache,
        canceler,
      )
      .then((aggregate) => {
        if (aggregate) {
          if (!$scope.aggregate || !$scope.filterBar.page) {
            $scope.aggregate = aggregate;
            $scope.aggregate.isComplete = false;
          } else {
            $scope.aggregate.isComplete = aggregate.cells.length == 0;
            aggregate.cells.forEach(function(cell) {
              $scope.aggregate.cells.push(cell);
            }, this);
          }
        }
        if ($scope.aggregate) {
          $scope.aggregate.blocked = false;
        }
        $scope.$broadcast('aggregateLoaded');
      })
      .catch(error => {
        ErrorHandlerService.handle(error);
      });
  };

  $scope.aggregate_more = function() {
    if (!$scope.filterBar) return;
    const blocked = $scope.aggregate ? $scope.aggregate.blocked : true;
    $scope.filterBar.page = blocked ? $scope.filterBar.page : $scope.filterBar.page + 1;
    if (!blocked) $scope.loadAggregate(function(error) {
      if (error) globalAlert(error.message);
    }, false);
  };

  $scope.searchAggregate = function(event) {
    if (event && event.keyCode != 13) return false;
    const keyword = angular.element('#aggregate-search-modal').val();
    $scope.filterBar.lookup = keyword;
    $scope.loadAggregate(function(error) {
      if (error) globalAlert(error.message);
    }, true);
  };

  $scope.loadAggregate(null, true);

  $scope.isAggregateLoading = function() {
    return !$scope.aggregate || $scope.aggregate.blocked;
  };

  $scope.hasData = function() {
    return ($scope.aggregate && $scope.aggregate.cells && $scope.aggregate.cells.length > 0);
  };

  $scope.select = function(dim) {
    if (dim.dimension) {
      $scope.openNode('hierarhy', dim.toString());
      $scope.openNode('dimension', dim.dimension.toString());
    } else {
      $scope.openNode('dimension', dim.toString());
    }
    $scope.filterBar.setDrilldown(dim.toString());
    $scope.filterBar.setKeyword('');
    $scope.filterBar.page = 0;
    $scope.filterBar.lookup = null;
    $scope.loadAggregate();
  };

  $scope.$on('reload', () => $scope.loadAggregate(null, true));

  $scope.hasCellFilter = function(drill, cell) {
    const filter = $scope.model.getCellFilter(drill, cell);
    return $scope.filter.hasFilter(filter);
  };

  $scope.focusName = function() {
    // if (!$scope.filter.saved) {
    //   $scope.filter.name = '';
    // }
  };

  $scope.cleanName = function() {
    $scope.filter.name = '';
  };


  $scope.invertFilter = f => {
    $scope.filter.invertFilter(f);
    $scope.updateAsText();
    $scope.findFilterError('data-filter');
  };

  $scope.keyWordClick = keyWords => {
    if (!keyWords.trim()) {
      return;
    }
    const re = (keyWords.match(/["'](.*)["']/));

    if (re) {
      $scope.filter.addKeyword(re[1]);
    } else {
      keyWords.split(' ').forEach((keyword) => {
        $scope.filter.addKeyword(keyword);
      });
    }
    $scope.updateAsText();
  };

  $scope.removeFilter = f => {
    $scope.filter.removeFilter(f);
    $scope.updateAsText();
    $scope.findFilterError('data-filter');
  };

  $scope.setCellFilter = (drill, cell) => {
    const filter = $scope.model.getCellFilter(drill, cell);
    $scope.filter.toggleFilter(filter);
    $scope.updateAsText();
    $scope.findFilterError('data-filter');
  };

  $scope.selectAll = () => {
    if (!$scope.aggregate || !$scope.aggregate.cells) {
      return;
    }
    const drill = $scope.filterBar.drilldown[0];
    const cells = $scope.aggregate.cells;
    cells.forEach(cell => {
      const filter = $scope.model.getCellFilter(drill, cell);
      $scope.filter.toggleFilter(filter);
    });
    $scope.CurrentFilterService.rebuildVisibleDimensions();
    $scope.RouterService.filterChanged();
  };


  $scope.ok = (testMail) => {

    $scope.awaiting = true;
    if (testMail) {
      $scope.testMail = false;
      $scope.filter.testmail = true;
      if (!$scope.filter.emails) $scope.filter.emails = $scope.notify2.adminMail;
    } else {
      delete $scope.filter.testmail;
    }

    if (filter.switch_to && !filter.switch_to.accountConf && !filter.switch_to.agentConf) delete filter.switch_to;
    $scope.successSended = false;
    let errorStatus = '';
    let errorText = '';

    if ($scope.CurrentFilterService.iFrameParams) Object.assign($scope.filter, $scope.CurrentFilterService.iFrameParams);

    if ($scope.filter.content_type === 'lateuploadfilter' || $scope.filter.content_type === 'inactiveagentfilter') {
      if (!angular.isNumber($scope.filter.timeout)) {
        errorStatus = gettext('Ошибка');
        errorText = gettext('Введите целое положительное число в поле "Задержка (часов)"');
      }
    }

    if ($scope.filter.content_type === 'ocrparser' && $scope.filter.action === 'abbyy') {
      if ($scope.filter.ocr_app_id == '' || $scope.filter.ocr_app_password == '') {
        errorStatus = gettext('Ошибка');
        errorText = gettext('Укажите AppID и пароль');
      }
    }

    if ($scope.filter.content_type === 'corpusprocessfilter') {
      if (!$scope.filter.corpus_data) {
        errorStatus = gettext('Ошибка');
        errorText = gettext('Заполните словарь');
      }
    }

    if (filter.content_type === 'backupfilter') {
      if (!angular.isNumber($scope.filter.hdd_alarm_percentage) || !angular.isNumber(
          $scope.filter.hdd_hard_percentage)) {
        errorStatus = gettext('Ошибка');
        errorText = gettext('Введите целое число');
      }
      if ($scope.filter.hdd_backup_path == '') {
        errorStatus = gettext('Ошибка');
        errorText = gettext('Задайте путь резервного копирования');
      }
      if ($scope.filter.hdd_alarm_percentage < 0 || $scope.filter.hdd_hard_percentage < 0) {
        errorStatus = gettext('Ошибка');
        errorText = gettext('Значения должны быть больше нуля');
      }
    }

    if ($scope.filter.name == '') {
      errorStatus = gettext('Ошибка');
      errorText = gettext('Задайте имя фильтра');
    }

    if (testMail && errorText) {
      $scope.testMail = true;
    }

    if (errorText !== '' && errorStatus !== '') {
      $scope.awaiting = false;
      $scope.errorMessage.sourse = 'save-filter';
      $scope.errorMessage.text = errorText;

      // $scope.ErrorHandlerService.showErrorMessageBox(errorStatus, errorText);
      return;
    }

    if (asNew) {
      $scope.filter.id = 0;
    }

    if ($scope.filter.isCardFilter) {
      delete $scope.filter.cardFilter;
      delete $scope.filter.children;
    }
    if ($scope.RouterService.isEditDasboard) $modalInstance.close($scope.filter);
    else FilterResource.save($scope.filter, function(status, data, error) {
      $scope.awaiting = false;
      if (error) {
        if (testMail) $scope.testMail = true;
        $scope.ErrorHandlerService.showErrorMessageBox(`${gettext('Ошибка')}: ${status}`, data, null, true);
      } else {
        if (testMail) $scope.testMail = true;
        if (status === 200) {
          if (!testMail) {
            $scope.ErrorHandlerService.notShowErrorMessageBox = false;
            $modalInstance.close(data);
          } else {
            let originalFilter = $scope.getOriginalFilter(data.id);
            if (!originalFilter) {
              originalFilter = new Filter();
              Object.assign(originalFilter, data);
              CurrentFilterService.FiltersService.filters.push(originalFilter);
            } else {
              Object.keys(originalFilter).map(k => delete originalFilter[k]);
              Object.assign(originalFilter, data);
            }
            $scope.filter = data;
            if (filter.notify || filter.reporting_schedule_type) {
              $scope.successSended = true;
              $scope.$timeout(() => $scope.successSended = false, 3000);
            }
            // RouterService.selectFilter(data.id);
          }
        }
        if (status === 422) {
          if (data && '__all__' in data) $scope.errorMessage.text = data['__all__'][0];
          else if (data && data.corpus_data && data.corpus_data[0]) $scope.errorMessage.text = data.corpus_data[0];
          else $scope.errorMessage.text = gettext('Заполните необходимые поля.');
          $scope.errorMessage.sourse = 'save-filter';
          $scope.errors = data;
        }
      }
    });
  };

  $scope.cancel = () => {
    $scope.ErrorHandlerService.notShowErrorMessageBox = false;
    $modalInstance.dismiss('cancel');
    $scope.ErrorHandlerService.filterErrorMessage = {};
  };

  $scope.delete = () => {
    $modal.open({
        templateUrl: 'boolDialog.html',
        controller: boolDialogCtrl,
      })
      .result.then(result => {
        $scope.awaiting = true;
        if (result) {
          $scope.filter.deleted = true;
          if ($scope.RouterService.isEditDasboard) $modalInstance.close($scope.filter);
          else return FilterResource.delete($scope.filter)
            .then(() => {
              $scope.awaiting = false;
              $scope.ErrorHandlerService.notShowErrorMessageBox = false;
              $modalInstance.close($scope.filter);
            })
            .catch((error) => {
              $scope.awaiting = false;
              globalAlert(error);
            });
        }
      })
      .catch((error) => {
        $scope.awaiting = false;
        console.error(error);
      });
  };

  $scope.show = {
    notify: () => !$scope.filter.send_threshold,
    threshold: () => $scope.filter.send_threshold && $scope.filter.isAnalysis && !$scope.filter.isEventRiver,
    sendPdf: () => $scope.filter.content_type !== 'policy' && $scope.filter.content_type !== 'corpusprocessfilter',
    sendOptions: () => $scope.filter.content_type !== 'policy' && $scope.filter.content_type !== 'corpusprocessfilter',
    notifyTab: () => $scope.filter.content_type === 'filter' || $scope.filter.content_type === 'policy' ||
      $scope.filter.content_type === 'corpusprocessfilter' || $scope.filter.isDashboard || $scope.filter.isCard ||
      $scope.filter.content_type === 'filteraggregatealertfilter',
    filtersTab: () => !($scope.serverPolicies || $scope.filter.content_type === 'folder' || $scope.filter.content_type === 'mailgrabber' || $scope.filter.content_type === 'msgraphgrabber'),
    category: () => $scope.filter.content_type === 'policy' || $scope.filter.content_type === 'corpusprocessfilter' ||
      $scope.filter.content_type === 'letteryourself',
    politicOptions: () => $scope.filter.content_type !== 'mailgrabber' && $scope.filter.content_type !== 'msgraphgrabber' && $scope.filter.content_type !== 'filter' &&
      $scope.filter.content_type !== 'dashboard' && $scope.filter.content_type !== 'folder' &&
      $scope.filter.content_type !== 'filteraggregatealertfilter',
    lateUploadFilter: () => $scope.filter.content_type === 'lateuploadfilter' || $scope.filter.content_type === 'inactiveagentfilter',
    corpusprocessfilter: () => $scope.filter.content_type === 'corpusprocessfilter',
    incidentTab: () => $scope.filter.content_type === 'corpusprocessfilter' || $scope.filter.content_type === 'policy',
    backupfilter: () => $scope.filter.content_type === 'backupfilter',
    mailgrabber: () => $scope.filter.content_type === 'mailgrabber',
    msgraphgrabber: () => $scope.filter.content_type === 'msgraphgrabber',
    ocrparser: () => $scope.filter.content_type === 'ocrparser',
    emailTemplete: () => $scope.emailTemplete.show,
    newEventsNotify: () => !$scope.filter.isDashboard && !$scope.filter.isCard,
    lens: () => ($scope.filter.content_type === 'filter' || $scope.filter.content_type === 'filteraggregatealertfilter') &&
      !$scope.filter.isPolitic && !$scope.filter.isContainer,

  };

  $scope.updateAsText();
};



// WEBPACK FOOTER //
// ./src/filter/editor/filter-editor-modal.component.js